<template>
  <div style="display: flex;flex-direction: column">
    <div
      style="height: 20px;width: 100px;background: pink;overflow: hidden;align-self: flex-end"
    >
      <div>
        <SjColorPicker v-model="color" borderRadius> 圆角颜色器</SjColorPicker>
      </div>
    </div>
    <div>颜色：{{ color }}</div>
    <SjColorPicker v-model="color">方形颜色选择器</SjColorPicker>
    <div>颜色：{{ color }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      color: "#ffffff"
    };
  }
};
</script>

<style scoped lang="less"></style>
